import React, { useEffect, useState } from "react";
import { Button, Box } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { get, put } from "../../../utils/api";
import DynamicTable from "../../Common/DynamicTable";
import { validateTable } from "../../../utils/validateTable";
import { restructureData } from "../../../utils/restructureData";
import MessagePopup from "../../Masters/MessagePopup";
import { useParams } from "react-router-dom";
import ReviewBox from "../../Common/ReviewBox";
import { brsrReview, reviewBRSR } from "../../../utils/companyId";
import { currentYear } from "../../../utils/generateYearRanges";
import style from "../../../styles/brsr/general.module.css";
import BRSRFile from "../../Common/BRSRFile";

const inputData = [
  {
    fieldName: "businessActivities",
    title:
      "16. Details of Business Activities (accounting for 90% of the turnover)",
    type: "array",
    fields: [
      {
        fieldName: "mainActivity",
        title: "Description of Main Activity",
        placeholder: "Enter Text",
        type: "text",
        width: "15rem",
      },
      {
        fieldName: "businessActivity",
        title: "Description of Business Activity",
        placeholder: "Enter Text",
        type: "text",
        width: "15rem",
      },
      {
        fieldName: "turnoverPercentage",
        title: "% of Turnover of the entity",
        placeholder: "Enter Percentage",
        type: "percentage",
        width: "15rem",
      },
    ],
  },
];

const prodData = [
  {
    fieldName: "productsOrServices",
    title:
      "17. Products / Services sold by the entity (accounting for 90% of the entity’s Turnover)",
    type: "array",
    fields: [
      {
        fieldName: "productOrService",
        title: "Product / Service",
        placeholder: "Enter Text",
        type: "text",
        width: "15rem",
      },
      {
        fieldName: "nicCode",
        title: "NIC Code",
        placeholder: "Enter Text",
        type: "text",
        width: "15rem",
      },
      {
        fieldName: "turnoverPercentage",
        title: "% of Total Turnover Contributed",
        placeholder: "Enter Percentage",
        type: "percentage",
        width: "15rem",
      },
    ],
  },
];

const ProductAndServices = ({ onSave, hide = false, removeUpload = false }) => {
  const { id } = useParams();
  const [modalupload, setModalUpload] = useState({
    businessActivitiesDoc: false,
    productsOrServicesDoc: false,
  });
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({});
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(`/brsr/get?type=SectionA&id=${id}`);
      const res1 = res?.data?.data?.BRSRSectionA?.productServices;
      setFormData(res1);
      if (
        res?.data?.data?.year
          ? res?.data?.data?.year < currentYear - 1
          : false || !brsrReview
      )
        setDisabled(true);

      setData(res1);
    } catch (err) {
      console.log(err);
    }
  };

  const [tables, setTables] = useState([]);
  const [prodTable, setProdTable] = useState([]);
  const [err1, setErr1] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [formData, setFormData] = useState({});
  const handleSubmit = async () => {
    if (!disabled) {
      try {
        let v1 = validateTable(inputData, tables, setErrors);
        let v2 = validateTable(prodData, prodTable, setErr1);
        if (!v1 || !v2) return;

        let transformedData = {
          productServices: {
            ...formData,
            ...restructureData(tables),
            ...restructureData(prodTable),
          },
          productServicesSubmitted: true,
          type: "SectionA",
        };

        const res = await put(`/brsr/update?id=${id}`, transformedData);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        onSave();
      } catch (error) {
        console.log(error);
        setsnackOpen({
          open: true,
          message: error.data.message,
          severity: "error",
        });
      }
    } else onSave();
  };

  return (
    <Box>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      <p className={style.subHeading}>II. PRODUCTS / SERVICES</p>
      <DynamicTable
        {...{
          inputData,
          // subHeading: "II. PRODUCTS / SERVICES",
          handleSubmit,
          tables,
          setTables,
          errors,
          setErrors,
          data,
          ml: "1.5rem",
          width: "97.5%",
          disabled,
          hide,
        }}
      />
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "businessActivitiesDoc",
          ml: 3,
          removeUpload,
        }}
      />
      <DynamicTable
        {...{
          inputData: prodData,
          // subHeading: "II. PRODUCTS/SERVICES",
          handleSubmit,
          tables: prodTable,
          setTables: setProdTable,
          errors: err1,
          setErrors: setErr1,
          data,
          ml: "1.5rem",
          width: "97.5%",
          disabled,
          hide,
        }}
      />
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "productsOrServicesDoc",
          ml: 3,
          removeUpload,
        }}
      />
      {!hide && (
        <>
          {brsrReview ? (
            <Box sx={{ ml: "1.5rem", width: "97.5%" }}>
              <ReviewBox
                url={`/brsr/review/${id}`}
                handleSubmit={handleSubmit}
              />
            </Box>
          ) : (
            <Box textAlign="right" sx={{ mt: 3 }}>
              <Button
                onClick={handleSubmit}
                variant="contained"
                sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
              >
                Save & Continue <EastIcon sx={{ ml: 2 }} />
              </Button>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default ProductAndServices;
